import type { FC } from 'react';
import * as Styled from './styled';

export const ScrollArowAnimated: FC = () => {
  return (
    <Styled.Wrapper>
      <div className="chevron" />
      <div className="chevron" />
      <div className="chevron" />
      <Styled.Text>scroll</Styled.Text>
    </Styled.Wrapper>
  );
};
